// Multivariate Dependencies
import React from 'react';
// Components
import { Icon } from '../../Icon';
import { Label } from '../../Label';
import { Container } from '../../../common/styles/container';
import { BadgeStylePropertiesBySize } from '../types/BadgeStylePropertiesBySize';
export var BadgeStructure = function (_a) {
    var leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, size = _a.size, children = _a.children, className = _a.className;
    var labelSize = BadgeStylePropertiesBySize[size].labelSize;
    return (React.createElement(Container, { className: className },
        leftIcon && React.createElement(Icon, { ariaLabel: "Badge left icon " + leftIcon, name: leftIcon }),
        React.createElement(Label, { size: labelSize }, children),
        rightIcon && React.createElement(Icon, { ariaLabel: "Badge right icon " + rightIcon, name: rightIcon })));
};
//# sourceMappingURL=BadgeStructure.js.map